import { createSelector } from 'reselect'

export const getSmsWasSent = createSelector(
  state => Boolean(state && state.common && state.common.form && state.common.form.wasSmsSent),
  wasSmsSent => wasSmsSent
)
